import React from 'react';
import { Button, Collapse } from 'reactstrap';

import { Desktop, Mobile } from '../Common/const';
import PDFBadge from './Badges/PDFBadge';
import QuestionCounter from './QuestionCounter';
import QuestionLink from './QuestionLink';
import StudyCounters from './StudyCounters';
import StudyListItem from './StudyListItem';

class ListGroupItem extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: false };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  renderNeedPub() {
    return (
      <a
        href="https://promotionwingman.com/how-to-submit-a-publication/"
        target="_blank"
        className="link-need-publication"
        rel="noreferrer"
      >
        We need this pub! Submit here!
      </a>
    );
  }

  openModal = () => {
    if (
      this.props.userSubscription?.warfarePlan &&
      this.props.location.pathname !== '/app/study/quals-and-certs' &&
      typeof this.props.openWarfareModal === 'function'
    ) {
      this.props.openWarfareModal();
    } else if (typeof this.props.openSwitchToPaid === 'function') {
      this.props.openSwitchToPaid();
    }
  };

  getAudioProgressForChapter = (chapterId) => {
    const chapterProgress = this.props.audioPlaylistsProgress[chapterId];
    if (chapterProgress?.accumulated > 0 && chapterProgress?.total > 0)
      return 100 * (chapterProgress.accumulated / chapterProgress.total);
    return 0;
  };

  render() {
    const _this = this;
    const isByReferenceView =
      this.props?.location?.pathname.split('/').pop() === 'study';

    const classes = `d-flex list-group-item flex-row align-items-center justify-content-between cursor-pointer`;
    let chevronCss = 'd-flex icon-expand mr-1 rotate';
    let questionCounter = '';
    const warfareCondition =
      this.props.userSubscription?.warfarePlan &&
      !this.props.location.pathname.includes('quals-and-certs');

    if (this.state.collapse) {
      chevronCss = 'icon-expand mr-1 rotate down';
    }

    let fullName = '';
    if (this.props.description) {
      fullName = `${this.props.name} - ${this.props.description}`;
    } else {
      fullName = this.props.name;
    }

    const studyProgramId = this.props.studyProgramId;

    if (this.props.chapters) {
      questionCounter = (
        <QuestionCounter
          count={this.props.chapters.length}
          noun={this.props.noun}
        />
      );
    }

    const placeholder = 'question/1/1';
    if (!this.props.actAsParent) {
      return (
        <StudyListItem
          {...this.props.chapters[0]}
          user={this.props.user}
          userSubscription={this.props.userSubscription}
          referenceName={this.props.name}
          nextUpItemIndex={0}
          nextUpSectionIndex={this.props.nextUpSectionIndex}
          studyProgramId={studyProgramId}
          location={this.props.location}
          setQuestionNotification={this.props.setQuestionNotification}
          setChapterId={this.props.setChapterId}
          openSwitchToPaid={() => this.openModal()}
          bookNeedPub={this.props.weNeedThisPublication}
          getPdfByReference={this.props.getPdfByReference}
          updateDisabledChapter={this.props.updateDisabledChapter}
          disabled={this.props.chapters[0].disabledChapter}
          startAudioPlaylist={this.props.startAudioPlaylist}
          updateAudioPlaylistProgress={this.props.updateAudioPlaylistProgress}
          setSwitchToPaidModalIsForAudio={
            this.props.setSwitchToPaidModalIsForAudio
          }
          openUpgradeSubscriptionForAudiosModal={
            this.props.openUpgradeSubscriptionForAudiosModal
          }
          audioProgress={
            isByReferenceView
              ? this.getAudioProgressForChapter(this.props.chapters[0].id)
              : null
          }
        />
      );
    }
    return (
      <div>
        <li className={classes} onClick={this.toggle}>
          <div className="titleAndNeedPub">
            <div className="d-flex flex-row align-items-center list-title ">
              <i className={chevronCss} />
              <span className="d-flex ml-2 mr-2">{fullName}</span>
              {this.props.isStudyPlan &&
                (() => {
                  const chapters = this.props.chapters || [];
                  const shouldShowReviewButton =
                    chapters.length > 0 &&
                    chapters.every(
                      (chapter) =>
                        chapter.new === '0' &&
                        chapter.learning === '0' &&
                        chapter.review === '0',
                    ) &&
                    chapters.some((chapter) => chapter.reviewInFuture !== '0');

                  if (!shouldShowReviewButton) return null;

                  const ids = chapters.map((chapter) => chapter.id);

                  return (
                    <div>
                      <Button
                        onClick={() => {
                          this.props.resetChapters({ chapterIds: ids });
                          window.location.reload();
                        }}
                        className="ml-5 button-review btn-outline-secondary rounded-lg"
                      >
                        Review again
                      </Button>
                    </div>
                  );
                })()}
            </div>

            {this.props.weNeedThisPublication && (
              <div className="needPub">{this.renderNeedPub()}</div>
            )}
          </div>

          <Mobile>
            <QuestionLink to={placeholder} count={this.props.chapters.length} />
          </Mobile>

          <Desktop>
            <div className="d-flex flex-row align-items-center">
              {/* this wrapper prevents the li.toggle from firing when the badge is clicked */}
              <div onClick={(e) => e.stopPropagation()}>
                <PDFBadge
                  disabled={
                    (this.props.userSubscription?.isCancelled &&
                      !this.props.userSubscription.status) ||
                    this.props.userSubscription?.status === 'trialing' ||
                    warfareCondition
                  }
                  onDisabledClick={() => this.openModal()}
                  PDFUrl={this.props.fullPDF}
                  text="Full PDF"
                  chapterId={this.props.id}
                  getPdfByReference={this.props.getPdfByReference}
                />
              </div>
              {questionCounter}
              {this.props.chapters?.length > 0 && (
                <StudyCounters
                  id={`p${this.props.chapters[0].id}`}
                  reviewWhen={this.props.reviewWhen}
                  new={this.props.new}
                  learning={this.props.learning}
                  review={this.props.review}
                />
              )}
            </div>
          </Desktop>
        </li>

        <Collapse
          className="list-group-flush bg-white pl-3"
          isOpen={this.state.collapse}
        >
          {this.props.chapters.map((chapter, index) => (
            <StudyListItem
              user={this.props.user}
              userSubscription={this.props.userSubscription}
              nextUpQualIndex={this.props.nextUpQualIndex}
              nextUpSectionIndex={this.props.nextUpSectionIndex}
              nextUpItemIndex={index}
              comingSoon={
                chapter.chapters !== undefined
                  ? chapter.chapters === null || !chapter.chapters[0]
                  : false
              }
              {...chapter}
              key={index}
              studyProgramId={studyProgramId}
              location={_this.props.location}
              setQuestionNotification={this.props.setQuestionNotification}
              setChapterId={this.props.setChapterId}
              openSwitchToPaid={() => this.openModal()}
              bookNeedPub={this.props.weNeedThisPublication}
              getPdfByReference={this.props.getPdfByReference}
              updateDisabledChapter={this.props.updateDisabledChapter}
              disabled={chapter.disabledChapter}
              startAudioPlaylist={this.props.startAudioPlaylist}
              updateAudioPlaylistProgress={
                this.props.updateAudioPlaylistProgress
              }
              setSwitchToPaidModalIsForAudio={
                this.props.setSwitchToPaidModalIsForAudio
              }
              openUpgradeSubscriptionForAudiosModal={
                this.props.openUpgradeSubscriptionForAudiosModal
              }
              audioProgress={
                isByReferenceView
                  ? this.getAudioProgressForChapter(chapter.id)
                  : null
              }
            />
          ))}
        </Collapse>
      </div>
    );
  }
}

export default ListGroupItem;
